import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { getGuardianStudentAssignments, getTeamsAssignments } from 'actions/assignments';
import LoadingCards from 'components/Presentation/Cards/LoadingCards';
import Task from 'components/Presentation/Task';
import SectionTitle from 'components/Presentation/SectionTitle';
import { CardsContainer } from 'components/Presentation/Cards/Card';
import { Expandable } from 'UI';
import { Icon, translate } from '@haldor/ui';
var MyTasks = /*#__PURE__*/function (_Component) {
  function MyTasks(props) {
    var _this;
    _classCallCheck(this, MyTasks);
    _this = _callSuper(this, MyTasks, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var promises = [];
      if (_this.props.activeStudent != null && _this.props.activeStudent.services.haldor && (_this.props.assignments == null || _this.props.assignments.length == 0)) {
        var haldorAssignmentsPromise = _this.props.getGuardianStudentAssignments(_this.props.activeStudent.id);
        promises.push(haldorAssignmentsPromise);
      }
      if (_this.props.activeStudent != null && _this.props.activeStudent.services.microsoft && (_this.props.assignments == null || _this.props.assignments.length == 0)) {
        var teamsAssignmentsPromise = _this.props.getTeamsAssignments(_this.props.activeStudent.id);
        promises.push(teamsAssignmentsPromise);
      }
      Promise.all(promises).then(function () {
        _this.setState({
          loading: false
        });
      });
    });
    _defineProperty(_this, "renderContent", function () {
      if (_this.state.loading) {
        return /*#__PURE__*/React.createElement(LoadingCards, {
          count: 3
        });
      }
      return /*#__PURE__*/React.createElement("div", null, _this.renderOverdue(), _this.renderCurrent(), _this.renderUpcoming(), _this.renderSubmitted());
    });
    _defineProperty(_this, "renderOverdue", function () {
      var limit = 99999;
      if (_this.props.limit != null && _this.props.limit) {
        limit = _this.props.limit;
      }
      var list = _this.props.overdue;
      if (_this.props.groupid != null) {
        list = list.filter(function (t) {
          return t.sectionId == _this.props.groupid;
        });
      }
      if (_this.props.plan != null) {
        list = list.filter(function (t) {
          return _this.props.plan.find(function (d) {
            return d.assignmentId == t.id;
          }) != null;
        });
      }
      if (list.length == 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Expandable, {
        open: false,
        title: _this.props.translate('Overdue')
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return /*#__PURE__*/React.createElement(Task, {
            key: assignment.id != -1 ? assignment.id : assignment.externalId,
            assignment: assignment,
            status: _this.props.status
          });
        }
      })), _this.props.limit != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          width: '100%',
          textAlign: 'center',
          display: 'block'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          color: '#ccc',
          textDecoration: 'none'
        },
        to: "/assignments"
      }, _this.props.translate('Show all'))) : null);
    });
    _defineProperty(_this, "renderCurrent", function () {
      var limit = 99999;
      if (_this.props.limit != null && _this.props.limit) {
        limit = _this.props.limit;
      }
      var list = _this.props.current;
      if (_this.props.groupid != null) {
        list = list.filter(function (t) {
          return t.sectionId == _this.props.groupid;
        });
      }
      if (_this.props.plan != null) {
        list = list.filter(function (t) {
          return _this.props.plan.find(function (d) {
            return d.assignmentId == t.id;
          }) != null;
        });
      }
      if (list.length == 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Expandable, {
        open: true,
        title: _this.props.translate('Assignment_Assigned')
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return /*#__PURE__*/React.createElement(Task, {
            key: assignment.id != -1 ? assignment.id : assignment.externalId,
            assignment: assignment,
            status: _this.props.status
          });
        }
      })), _this.props.limit != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          width: '100%',
          textAlign: 'center',
          display: 'block'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          color: '#ccc',
          textDecoration: 'none'
        },
        to: "/assignments"
      }, _this.props.translate('Show all'))) : null);
    });
    _defineProperty(_this, "renderUpcoming", function () {
      var limit = 99999;
      if (_this.props.limit != null && _this.props.limit) {
        limit = _this.props.limit;
      }
      var list = _this.props.upcoming;
      if (_this.props.groupid != null) {
        list = list.filter(function (t) {
          return t.sectionId == _this.props.groupid;
        });
      }
      if (_this.props.plan != null) {
        list = list.filter(function (t) {
          return _this.props.plan.find(function (d) {
            return d.assignmentId == t.id;
          }) != null;
        });
      }
      if (list.length == 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Expandable, {
        open: false,
        title: _this.props.translate('Upcoming')
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return /*#__PURE__*/React.createElement(Task, {
            key: assignment.id != -1 ? assignment.id : assignment.externalId,
            assignment: assignment,
            status: _this.props.status
          });
        }
      })), _this.props.limit != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          width: '100%',
          textAlign: 'center',
          display: 'block'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          color: '#ccc',
          textDecoration: 'none'
        },
        to: "/assignments"
      }, _this.props.translate('Show all'))) : null);
    });
    _defineProperty(_this, "renderSubmitted", function () {
      var limit = 99999;
      if (_this.props.limit != null && _this.props.limit) {
        limit = _this.props.limit;
      }
      var list = _this.props.submitted;
      if (_this.props.groupid != null) {
        list = list.filter(function (t) {
          return t.sectionId == _this.props.groupid;
        });
      }
      if (_this.props.plan != null) {
        list = list.filter(function (t) {
          return _this.props.plan.find(function (d) {
            return d.assignmentId == t.id;
          }) != null;
        });
      }
      if (list.length == 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Expandable, {
        open: false,
        title: _this.props.translate('Assignment_Completed')
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return /*#__PURE__*/React.createElement(Task, {
            key: assignment.id != -1 ? assignment.id : assignment.externalId,
            assignment: assignment,
            status: _this.props.status
          });
        }
      })), _this.props.limit != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          width: '100%',
          textAlign: 'center',
          display: 'block'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          color: '#ccc',
          textDecoration: 'none'
        },
        to: "/assignments"
      }, _this.props.translate('Show all'))) : null);
    });
    _this.state = {
      lists: [],
      tasks: null,
      loading: true
    };
    return _this;
  }
  _inherits(MyTasks, _Component);
  return _createClass(MyTasks, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "section",
        id: "section-assignment",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "my_tasks"
      }, this.props.overview ? /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Icon, {
        name: "Assignments"
      }), /*#__PURE__*/React.createElement("span", null, this.props.translate('Assignments/Homework')), this.props.limit != null ? /*#__PURE__*/React.createElement(Link, {
        to: "/assignments",
        className: "see-more"
      }, this.props.translate('Show all assignments')) : null) : null, this.renderContent()));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    assignments: state.assignments.assignments,
    tasks: state.assignments.assignments,
    overdue: state.assignments.overdue,
    current: state.assignments.current,
    upcoming: state.assignments.upcoming,
    submitted: state.assignments.submitted,
    status: state.base.status,
    sections: state.groups.groups,
    translate: translate(state.Languages.translations)
  };
};
export default connect(mapStateToProps, {
  getGuardianStudentAssignments: getGuardianStudentAssignments,
  getTeamsAssignments: getTeamsAssignments
})(MyTasks);